
import { Mixins, Component, Prop, Watch } from 'vue-property-decorator'
import * as T from '@/types'
import S from '@/store'

import ViewSidebarMixin from '@/mixins/mixin-view-sidebar'
import { formatShortDate } from '@/utils/utils-datetime'

import {
    UiBox,
    UiEmptyState, 
    UiIcon, 
    UiList,
    UiListItem,
    UiLoadingOverlay,
    UiSidebar,
} from '@hubsolv/hubsolv-ui'

import UiDownloadButton from '@/components/ui/inputs/UiDownloadButton.vue'

enum TabKey {
    FILES = 'files',
}

interface TabDefinition extends T.TabDefinition<TabKey> {}

@Component({
    components: {
        UiBox,
        UiDownloadButton,
        UiEmptyState, 
        UiIcon, 
        UiList,
        UiListItem,
        UiLoadingOverlay,
        UiSidebar,
    },
})
export default class ViewCasesSidebar extends Mixins<ViewSidebarMixin<T.Case, TabKey, TabDefinition>>(ViewSidebarMixin) {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////
    
    @Prop({type: Boolean, default: false}) compact!: Boolean

    ////////////////////////////////////////////////////////////////
    // Vuex bindings
    ////////////////////////////////////////////////////////////////
    
    @S.Files.Action downloadFiles!: any

    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get tabs () {
        return [
            { key: TabKey.FILES, label: 'Files' },
        ]
    }

    get selectedCase () {
        return this.oneSelected
    }

    ////////////////////////////////////////////////////////////////
    // methods
    ////////////////////////////////////////////////////////////////

    setDefaultTab () {
        this.currentTab = TabKey.FILES
    }

    ////////////////////////////////////////////////////////////////
    // download
    ////////////////////////////////////////////////////////////////

    downloading: boolean = false
    
    async onDownload (fileIds: T.FileId[]){
        try {
            this.downloading = true
            await this.downloadFiles({fileIds: fileIds.slice(0,10)})
        } catch (error) {
            console.log('onDownload failed:', error)
        } finally {
            this.downloading = false
        }
    }

    get downloadButtonLabel () {
        return this.downloading? `Downloading...`: `Download all files`
    }

}
